import {useEffect} from "react";
import Api from "../../fetchs/Api";
import ApiInsertarBusquedaClic from "../../fetchs/ApiInsertarBusquedaClic";
import ControlledTabs from "../componentesSecundarios/ControlledTabs"
import Modals from "../../componentesHTML/componentesSecundarios/Modals"
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import Highlighter from "react-highlight-words"
import latinize from 'latinize';
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorTemas(parametros){
  const _updateTotalDatos= useStoreGlobal(useShallow((state) => state._updateTotalDatos));
  let var_ingles = "es";
  if (window.location.href.indexOf("en.") > -1) {
      var_ingles = "en";
  }
  function fecha(fecha){
    let fec = fecha.split("T");
    return fec[0];
  }
  let idioma= var_ingles==="es"?"Fecha de última actualización:":"Date for last update:";
  const registradatos = ((TITULO,URL,metodoBusqueda) => {
    TITULO= TITULO.replace(/['°|@_=¿?¡!:/~<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
      let metodo="";
      if (metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (metodoBusqueda === 3){
        metodo="Frase completa";
      }
      const param = {
        CONTADOR_CLICK: 1,
        ID_COLECCION: "8",
        IP_USER: "",
        Metodo: metodo,
        Palabra_relacionada: "",
        TEXTO_BUSCADO: parametros.textoBusqueda,
        TITULO_URL: TITULO,
        URL: URL
      };
    ApiInsertarBusquedaClic(param);
  });
    const highlightTexto = (textoSuggest) => {
        let campo = document.getElementById('inputQ').value.trim();
        campo= campo.replace(/['°|@_=¿?¡!:~/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        campo= trataTextoHigh(campo);
        let textInputAux = campo.split(" ");
        let concatena= [];
        for (const word of textInputAux) {
          concatena.push(`${word}`); 
        }
        return  (
            <Highlighter
                    highlightClassName="highlight"
                    searchWords={concatena}
                    autoEscape={true}
                    textToHighlight= {textoSuggest}
                    sanitize={sanitizeText}
                /> 
        );
    }
    const sanitizeText = (text) => {
      return latinize(text);
    };
    function trataTextoHigh(texto) { 
    let articulos = [
        "insert", "drop", "delete", "truncate", ";", "--", "xp_", "in", "table", "exec", "of", "with", "the", "from", "al", "as", "is", "can", " also ", " already ", " more ", " you ", " others ", " and ", " but ", " between ", " are ", " than ", "one", "no", "your", "it",
        "a", "e", "i", "o", "u", "adónde", "al", "algo", "alguien", "alguna", "algunas", "alguno", "algunos", "ante", "aquel", "aquél",
        "aquella", "aquélla", "aquellas", "aquéllas", "aquello", "aquellos", "aquéllos", "bajo", "cabe",
        "como", "cómo", "con", "conmigo", "consigo", "contigo", "contra", "cual", "cuál", "cuales", "cuáles",
        "cualesquiera", "cualquiera", "cuando", "cuándo", "cuanta", "cuánta", "cuantas", "cuántas", "cuánto",
        "cuantos", "cuántos", "cuya", "cuyas", "cuyo", "cuyos", "de", "del", "demás", "desde", "donde", "dónde",
        "durante", "el", "él", "ella", "ellas", "ello", "ellos", "en", "entre", "es", "esa", "ésa", "esas", "ésas", "ese",
        "ése", "eso", "esos", "ésos", "esotra", "esotro", "esta", "está", "ésta", "estas", "éstas", "este", "éste",
        "esto", "estos", "éstos", "hacia", "hasta", "la", "las", "le", "les", "lo", "los", "más", "me", "mediante",
        "mí", "mía", "mías", "mío", "míos", "misma", "mismas", "mismo", "mismos", "mucha", "muchas", "mucho",
        "muchos", "nada", "nadie", "ninguna", "ningunas", "ninguno", "ningunos", "no", "nos", "nosotras",
        "nosotros", "nuestra", "nuestras", "nuestro", "nuestros", "os", "otra", "otras", "otro", "otros",
        "para", "pero", "poca", "pocas", "poco", "pocos", "por", "puede", "que", "qué", "quien", "quién", "quienes", "quiénes",
        "se", "según", "sí", "sin", "so", "sobre", "son", "su", "suya", "suyas", "suyo", "suyos", "también", "tanta",
        "tantas", "tanto", "tantos", "te", "ti", "toda", "todas", "todo", "todos", "tras", "tú", "tuya", "tuyas", "tuyo",
        "tuyos", "última", "últimas", "último", "últimos", "un", "una", "unas", "uno", "unos", "usted", "ustedes", "varias",
        "varios", "versus", "vía", "vos", "vosotras", "vosotros", "vuestra", "vuestras", "vuestro", "vuestros", "y", "ya", "yo"
    ];
    let parrafo = (texto.replace(/\./g, '').trim());
    let palabras = parrafo.split(/\s/);
    for (let p = 0; p < palabras.length; p++) {
        for (let a = 0; a < articulos.length; a++) {
            if (articulos[a] == palabras[p].toLowerCase()) {
                palabras[p] = '';
                break;
            }
        }
    }
    let newTexto = palabras.join(' ');
    let textoTratado = newTexto.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '');
    return textoTratado;
    }
  if (parametros.coleccionTodo != "Todo") { 
    let apiData = [];
    let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
    let param = {
      busqueda: parametros.textoBusqueda,
      busquedaCiencia: "",
      filtrobusqueda: parametros.camposBuscador,
      idioma: var_ingles,
      metodoBusqueda: parametros.metodoBusqueda,
      orderby: parametros.camposOrden,
      orderbyAscDesc:parametros.ordenamiento,
      paginaFin: parametros.pageFin,
      paginaInicio: parametros.pageInicial
    };
    apiData = Api("/app/api/buscadorcore/v1/busquedaTemas/", param)
    function RegistraBus(data){
      if(data.length > 0)
        ApiInsertarBusqueda(parametros.textoBusqueda ,"8", data[0].TOTAL, metodo);
      else
        ApiInsertarBusqueda(parametros.textoBusqueda ,"8", 0, metodo);
    }
    useEffect(() => {
      if(parametros.coleccionTodo != "Todo"){
        if (!apiData.loading){
          RegistraBus(apiData.data)
        }
        if(apiData.data.length > 0) {
          document.getElementById('resultados').innerHTML= apiData.data[0].TOTAL;
          _updateTotalDatos({totalDatos:apiData.data[0].TOTAL});
        }else{
          _updateTotalDatos({totalDatos:0});
          document.getElementById('resultados').innerHTML= 0;
        }
      }
      },[apiData.data]);
    return(
      <div>
          {apiData.loading? <Modals />:
            apiData.data.map((datos,id) => (  
            <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorTemas-" + id} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + id}>
              <div style={{paddingLeft: "0px!important", display:"inline-flex"}} id={"titulo-" + id}>
                <a target="_blank" href={datos.URL} id={"TituloHip-"+ id}> 
                  <div onClick={() =>registradatos(datos.TITULO,datos.URL,parametros.metodoBusqueda)} id={"gadget-" + id}>
                    {highlightTexto(datos.TITULO)}
                  </div>
                </a>
              </div>
              <div className="col-xs-12" style={{paddingLeft: "0px"}} id={"nivel1-" + id}>
                <div className=" col-sm-12 todo" style={{paddingLeft: "0px"}} id={"nivel1-0-" + id}>
                  <p id={"tag_p_0-" + id} style={{paddingTop: "5px", textAlign:"justify"}}>
                    <a target="_blank" href={datos.URL} id={"tag_a_0-" + id}>
                      <img src={datos.IMAGEN} align="left" id={"imagen-" + id} style={{margin:"0px 16px 5px 0px"}} alt="" />
                    </a>
                    <span id={"parrafo-Temas-" + id}>
                      {highlightTexto(datos.DESCRIPCION)}
                    </span>
                  </p>
                </div> 
              </div>
              <div className="col-xs-12" style={{paddingLeft:"0px"}} id={"nivel3-" + id}>
                <div className="col-xs-12 formato_fecha" style={{paddingLeft: "0px"}} id={"nivel3-1-" + id}>
                  <span className="indLink" id="fecha_actual-0">{idioma + " " + fecha(datos.FECHA_PUBLICACION)}
                  </span>
                </div>
              </div>
              <ControlledTabs id={id} busqueda={parametros.textoBusqueda} coleccion="Temas" urlPrograma={datos.URL} idTema = {datos.ID_TEMA} var_ingles = {var_ingles}  />
            </div>
            ))
          } 
      </div>
    );
  }
  else{
    let datos=parametros.datos;
    let id= parametros.id;
    let metodo= parametros.metodo;
    return(
      <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorTemas-" + id} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + id}>
        <div style={{paddingLeft: "0px!important", display:"inline-flex"}} id={"titulo-" + id}>
          <a target="_blank" href={datos.URL} id={"TituloHip-"+ id}> 
            <div onClick={() =>registradatos(datos.TITULO, datos.URL, metodo)} id={"gadget-" + id} >
                {highlightTexto(datos.TITULO)}      
            </div>
          </a>
        </div>
        <div className="col-xs-12" style={{paddingLeft: "0px"}} id={"nivel1-" + id}>
          <div className=" col-sm-12 todo" style={{paddingLeft: "0px"}} id={"nivel1-0-" + id}>
            <p id={"tag_p_0-" + id} style={{paddingTop: "5px", textAlign:"justify"}}>
              <a target="_blank" href={datos.URL} id={"tag_a_0-" + id}>
                <img src={datos.IMAGEN} align="left" id={"imagen-" + id} style={{margin:"0px 16px 5px 0px"}} alt="" />
              </a>
              <span id={"parrafo-Temas-" + id}>
                {highlightTexto(datos.DESCRIPCION)}      
              </span>
            </p>
          </div> 
        </div>
          <div className="col-xs-12" style={{paddingLeft:"0px"}} id={"nivel3-" + id}>
            <div className="col-xs-12 formato_fecha" style={{paddingLeft: "0px"}} id={"nivel3-1-" + id}>
              <span className="indLink" id="fecha_actual-0">{idioma + " " + fecha(datos.FECHA_PUBLICACION)}
              </span>
            </div>
          </div>
          <ControlledTabs id={id} busqueda={parametros.textoBusqueda} coleccion="Temas" urlPrograma={datos.URL} idTema = {datos.ID_TEMA} var_ingles = {var_ingles}  />
        </div>
    );
  }
}

export default BuscadorTemas;